import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledTypography } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    topBarText = "topBarText",
    backgroundColor ="backgroundColor",
    textColor ="textColor"
}

interface Props extends WidgetProps {
    fields: {
        [fields.topBarText]: string;
        [fields.backgroundColor]: string;
        [fields.textColor]: string;
    };
}
export interface TopBarStyles {
    topbar?: InjectableCss;
}

const TopBar: React.FC<Props> = props => {
    React.useEffect(() => {
        document.body.classList.add("as-topbar-active");
        return () => {
            document.body.classList.remove("as-topbar-active");
        };
      }, []);
    const topBarStyles: TopBarStyles = {

        topbar: {
            css: css`
                align-items: center;
                background: ${props.fields[fields.backgroundColor]};
                color: ${props.fields[fields.textColor]};
                font-size: 14px;
                height: 50px;
                justify-content: center;
                line-height: 1.2;
                padding: 8px 20px;
                text-align: center;
                a {
                    background-color:transparent;
                }
                *,:after,:before {
                    box-sizing:inherit;
                }
                p {
                    margin: 0;
                }
                a {
                    color:${props.fields[fields.textColor]}!important;
                    transition:color .35s cubic-bezier(.3,.86,.36,.95);
                    -webkit-text-decoration: underline;
                    text-decoration: underline;
                    span{
                        color:${props.fields[fields.textColor]}!important;
                        &:hover {
                        }
                    }
                    &:hover {
                        -webkit-text-decoration: none;
                        text-decoration: none;
                        color:${props.fields[fields.backgroundColor]}!important;
                    }
                } 
                @media (min-width:520px) {
                        height: 33px;
                }
        `,
        }
    
    };
    return (
        <>
            <StyledTypography {...topBarStyles.topbar} as="div" data-test-selector="TopBar">
                {props.fields.topBarText && parse(props.fields.topBarText, parserOptions)}
            </StyledTypography>
        </>
    );
};
const definition: WidgetDefinition = {
    group: "Header",
    fieldDefinitions: [
        
        {
            name: fields.backgroundColor,
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "#c8102e",
        },{
            name: fields.textColor,
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "#fff",
        },
        {
            name: fields.topBarText,
            displayName: "Text",
            editorTemplate: "RichTextField",
            defaultValue: "",
            fieldType: "General",
            isRequired: true,
        }
    ],
};

const widgetModule: WidgetModule = {
    component: TopBar,
    definition,
};

export default widgetModule;